import { createRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { publicLayoutRoute } from '@/ui/pages/public'
import { useDocumentMeta } from '@/application/hooks/useDocumentMeta'
import { OG_IMAGE_URL } from '@/application/seo/site'
import { useLocalizedUrl } from '@/application/hooks/useLocalizedUrl'
import { InvestigatorsHeaderSection } from './components/InvestigatorsHeaderSection'
import { InvestigatorsGridSection } from './components/InvestigatorsGridSection'

export const publicInvestigatorsRoute = createRoute({
  getParentRoute: () => publicLayoutRoute,
  path: '/investigators',
  component: PublicInvestigatorsPage,
})

export function PublicInvestigatorsPage() {
  const { t } = useTranslation()

  const pageUrl = useLocalizedUrl('/investigators')

  useDocumentMeta({
    title: t('seo.investigators_title'),
    description: t('seo.investigators_description'),
    imageUrl: OG_IMAGE_URL,
    url: pageUrl,
    type: 'website',
  })

  return (
    <div className="m-auto w-full max-w-[100rem] bg-card grow px-8 py-10">
      <InvestigatorsHeaderSection />
      <InvestigatorsGridSection />
    </div>
  )
}
